module.exports = __webpack_public_path__ + "img/header.98ff8438.png";